import React from 'react'
import { render } from 'react-dom'
import { Router, browserHistory } from 'react-router'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import { createStore, applyMiddleware, compose } from 'redux'
import { requestEnder } from './middleware'
import rootReducer from './rootReducer'
import setAuthorizationToken from './utils/setAuthorizationToken'
import { fetchUser } from './actions/authActions'
import moment from 'moment'

import routes from './routes';

moment.locale('ru');

require('react-datepicker/dist/react-datepicker.css');
require('./css/datepicker.css');
require('react-select/dist/react-select.css');
require('./css/style.css');

export const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(thunk, requestEnder),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
  )
);

if(localStorage.authToken && localStorage.authToken.length !== 255){
  localStorage.removeItem('authToken');
}

if (localStorage.authToken) {
  setAuthorizationToken(localStorage.login + ' ' + localStorage.authToken);
  store.dispatch({type:'SET_CURRENT_USER',user:{user_fname:localStorage.login}});
  store.dispatch(fetchUser());
}

render(
  <Provider store={store}>
    <Router history={browserHistory} routes={routes} />
  </Provider>, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js